'use strict';

$(document).ready(function () {
    var checkPage = $('.get-page-type').val();
    var applySlick = {
        dots: checkPage === 'clp',
        infinite: false,
        variableWidth: true,
        rows: 2,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    row: 2,
                    variableWidth: false,
                    infinite: false,
                    dots: true
                }
            }
        ]
    };
    $('.cat-responsive').slick(applySlick);
});
